import Vue from 'vue';
import Subscriber from './Subscriber.vue';


const subscriber = function () {
    if (document.getElementById('subscriber_app')) {
        const $vm = new Vue({ el: '#subscriber_app', render: h => h(Subscriber) });
    }
};
export default subscriber;
subscriber();
